import React from 'react'

import { NavSubMenuDialogProvider } from '../NavSubMenuDialog'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const NavModalContent: React.FC<{
  closeModal: () => void
  lang?: string
  langModalButton?: () => void
  renderAllNavigationTabs?: boolean
}> = ({ closeModal, lang, langModalButton, renderAllNavigationTabs = false }) => {
  const viewModel = useViewModel({
    closeModal,
    renderAllNavigationTabs,
  })
  return (
    <NavSubMenuDialogProvider>
      <Template {...viewModel} lang={lang} langModalButton={langModalButton} />
    </NavSubMenuDialogProvider>
  )
}
